import React from 'react';
import './FunFact.css'
import { BiHeart} from "@react-icons/all-files/bi/BiHeart";
import { BiAward} from "@react-icons/all-files/bi/BiAward";
import { FcClock} from "@react-icons/all-files/fc/FcClock";
import { DiCode} from "@react-icons/all-files/di/DiCode";

const FunFact = () => {
    return (
        <div className="container m-3 mb-5">
            <h4>Fun Facts</h4>
            <hr style={{width: '8%',height: '2px', color:'blue'}}/>
            <div className="container fun-div align-item-center">
                <div className="me-5 funCart-area">  
                    <BiHeart className="fun-icon"/>
                    <h5>Happy Client</h5>
                    <h2>51</h2>
                </div>
                <div className="me-5 funCart-area">  
                    <BiAward className="fun-icon"/>
                    <h5>Awards Won</h5>
                    <h2>20</h2>
                </div>
                <div className="me-5 funCart-area">  
                    <FcClock className="fun-icon"/>
                    <h5>Working Hours</h5>
                    <h2>350</h2>
                </div>
                <div className="me-5 funCart-area">  
                    <DiCode className="fun-icon"/>
                    <h5>Lines of Code</h5>
                    <h2>21,000</h2>
                </div>
            </div>
        </div>
    );
};

export default FunFact;